export var MVPStatusEnum;
(function (MVPStatusEnum) {
    MVPStatusEnum[MVPStatusEnum["Pending"] = 0] = "Pending";
    MVPStatusEnum[MVPStatusEnum["Invited"] = 1] = "Invited";
    MVPStatusEnum[MVPStatusEnum["Registered"] = 2] = "Registered";
})(MVPStatusEnum || (MVPStatusEnum = {}));
export const MVPStatusEnumDisplay = {
    [MVPStatusEnum.Pending]: 'Pending',
    [MVPStatusEnum.Invited]: 'Invited',
    [MVPStatusEnum.Registered]: 'Registered'
};
